module.exports = __webpack_public_path__ + "static/media/picnic-4.177cc661.jpg";